import loginController from '@/scripts/libs/login/controller';

const kickUserOut = () => {
  document.body.innerHTML = 'Opps, you are not login, we will redirect you to the main page.';
  loginController.logout()
    .then(() => {
      window.location = '/';
    });
};

export default () => loginController.getUser()
  .then((user) => {
    if (!user) kickUserOut();
  })
  .catch((error) => {
    if (error.message === 'Unauthorized') {
      kickUserOut();
    }
    throw error;
  });
